import { SlideData } from './types';

export const slides: SlideData[] = [
  {
    image: '/images/CFSC_Launch_Photo.jpeg',
    title: 'Welcome to the Climate Finance and Sustainability Centre',
    subtitle: 'A collaborative initiative between MUBS, ARIN, and Frankfurt School of Finance & Management, bridging gaps in climate finance education across Africa',
    ctaText: 'Learn More'
  },
  {
    image: '/images/CAFP-Adaptation-Finance.JPG',
    title: 'Climate Adaptation Finance Professional Certificate',
    subtitle: 'Supporting sustainable development across Africa through professional training',
    ctaText: 'Join Our Programs'
  },
  {
    image: '/images/NIERA-Dissemination.jpg',
    title: 'Africa-Centered Research & Knowledge Exchange',
    subtitle: 'Creating a platform for research and knowledge-sharing tailored to Africa\'s climate challenges',
    ctaText: 'Explore Research'
  },
  {
    image: '/images/CFSC_Launch_Photo_3.jpeg',
    title: 'Partnerships for Change',
    subtitle: 'Collaborating with leading institutions to drive sustainable development and climate resilience across Africa',
    ctaText: 'Partner With Us'
  }
];